import(/* webpackMode: "eager" */ "/app/src/app/president/page.tsx");
